import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import qs from 'qs';
import defaultAvartar from '../asset/common/default-avatar.png';
import defaultStudentAvartar from '../asset/common/child-default.png';
import config from '../config';
export function getUrlQuery(url) {
  if (url) {
    var u = decodeURIComponent(url);
    var hashIndex = u.indexOf('#');
    if (hashIndex === -1) {
      return {};
    }
    var hash = u.slice(hashIndex + 1);
    var queryIndex = hash.indexOf('?');
    if (queryIndex === -1) {
      return {};
    }
    var query = hash.slice(queryIndex + 1);
    return qs.parse(query || '');
  }
  return qs.parse(window.location.hash.split('?')[1] || '');
}
export function getUrlPath(url) {
  if (url) {
    var u = decodeURIComponent(url);
    var hash = u.split('#')[1] || '';
    return hash.split('?')[0] || '/';
  }
  return window.location.hash.slice(1).split('?')[0] || '/';
}
export var runAtNextFrame = function runAtNextFrame(fn) {
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      fn();
    });
  });
};
export function onDocumentVisibleChange(callback) {
  // 设置隐藏属性和改变可见属性的事件的名称
  var hidden = 'hidden';
  var visibilityChange = 'visibilitychange';
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
    // @ts-ignore
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
    // @ts-ignore
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }
  // 如果浏览器不支持addEventListener 或 Page Visibility API 给出警告
  // @ts-ignore
  if (typeof document.addEventListener === 'undefined' || typeof document[hidden] === 'undefined') {
    console.log('This demo requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.');
    return function () {};
  }
  // 处理页面可见属性的改变
  var onVisibleChange = function onVisibleChange(e) {
    // @ts-ignore
    callback.call(window, document[hidden], e);
  };
  document.addEventListener(visibilityChange, onVisibleChange, false);
  window.addEventListener('beforeunload', function () {
    document.removeEventListener(visibilityChange, onVisibleChange, false);
  });
  return function () {
    document.removeEventListener(visibilityChange, onVisibleChange, false);
  };
}
export var wrapAvartarUrl = function wrapAvartarUrl(oldUrl) {
  return oldUrl ? "".concat(config.AVATAR_PREFIX).concat(oldUrl) : '';
};
export var formatPhone = function formatPhone(phone) {
  return phone;
};
export var formatCode = function formatCode(code) {
  return code;
};
export var onNumberInputChange = function onNumberInputChange(e, length, setMethod) {
  var origin = e.target.value;
  var v = origin.replace(/[^0-9]/g, '');
  // const threeReg = /^\d{4}.*/
  // const sevenReg = /^\d{3}\s\d{5}.*/
  // let { selectionEnd } = e.target
  // if (v > 3) {
  //   if ((origin.length === v.length && selectionEnd > 3) || (origin.length > v.length && selectionEnd === 4 && threeReg.test(origin))) {
  //     selectionEnd++
  //   }
  //   if (v > 7) {
  //     if ((origin.length - v.length === 1 && selectionEnd > 8) || (origin.length - v.length === 2 && selectionEnd === 9 && sevenReg.test(origin))) {
  //       selectionEnd++
  //     }
  //   }
  // }
  // if (v.length > length) {
  //   e.preventDefault()
  //   return false
  // }
  // runAtNextFrame(() => {
  //   e.target.setSelectionRange(selectionEnd, selectionEnd)
  // })
  return setMethod(v.slice(0, length));
};
export function forbidBodyScroll() {
  document.body.className += ' overflow-hidden';
}
export function recoverBodyScroll() {
  var classNames = document.body.className.split(' ');
  document.body.className = classNames.filter(function (c) {
    return c !== 'overflow-hidden';
  }).join(' ');
}
export var calcElementHeight = function calcElementHeight(elId) {
  var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  if (document.querySelector("#".concat(elId))) {
    // @ts-ignore
    return windowHeight - document.querySelector("#".concat(elId)).getBoundingClientRect().top;
  }
  return 0;
};
export var downloadFilePub = function downloadFilePub(resourceUrl, fileName) {
  var x = new XMLHttpRequest();
  x.open('GET', resourceUrl, true);
  x.responseType = 'blob';
  // eslint-disable-next-line func-names
  x.onload = function (e) {
    var url = window.URL.createObjectURL(x.response);
    var a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
  };
  x.send();
  return false;
};
// check_webp_feature:
//   'feature' can be one of 'lossy', 'lossless', 'alpha' or 'animation'.
//   'callback(feature, result)' will be passed back the detection result (in an asynchronous way!)
export function checkWebpFeature(feature, callback) {
  return new Promise(function (resolve) {
    var kTestImages = {
      lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
      lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
      alpha: 'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
      animation: 'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA'
    };
    var img = new Image();
    img.onload = function () {
      var result = img.width > 0 && img.height > 0;
      callback && callback(result);
      resolve(result);
    };
    img.onerror = function () {
      callback && callback(false);
      resolve(false);
    };
    img.src = "data:image/webp;base64,".concat(kTestImages[feature]);
  });
}
export function checkAllWebpFeature(callback) {
  return new Promise(function (resolve) {
    Promise.all([checkWebpFeature('lossy'), checkWebpFeature('lossless'), checkWebpFeature('alpha'), checkWebpFeature('animation')]).then(function (res) {
      if (res.every(function (sup) {
        return !!sup;
      })) {
        resolve(true);
        callback && callback(true);
      } else {
        resolve(false);
        callback && callback(false);
      }
    });
  });
}
export function BrowserType() {
  // 权重：系统 + 系统版本 > 平台 > 内核 + 载体 + 内核版本 + 载体版本 > 外壳 + 外壳版本
  var ua = navigator.userAgent.toLowerCase();
  var testUa = function testUa(regexp) {
    return regexp.test(ua);
  };
  var testVs = function testVs(regexp) {
    return ua.match(regexp).toString().replace(/[^0-9|_.]/g, '').replace(/_/g, '.');
  };
  // 系统
  var system = 'unknow';
  if (testUa(/windows|win32|win64|wow32|wow64/g)) {
    system = 'windows'; // windows系统
  } else if (testUa(/macintosh|macintel/g)) {
    system = 'macos'; // macos系统
  } else if (testUa(/x11/g)) {
    system = 'linux'; // linux系统
  } else if (testUa(/android|adr/g)) {
    system = 'android'; // android系统
  } else if (testUa(/ios|iphone|ipad|ipod|iwatch/g)) {
    system = 'ios'; // ios系统
  }
  // 系统版本
  var systemVs = 'unknow';
  if (system === 'windows') {
    if (testUa(/windows nt 5.0|windows 2000/g)) {
      systemVs = '2000';
    } else if (testUa(/windows nt 5.1|windows xp/g)) {
      systemVs = 'xp';
    } else if (testUa(/windows nt 5.2|windows 2003/g)) {
      systemVs = '2003';
    } else if (testUa(/windows nt 6.0|windows vista/g)) {
      systemVs = 'vista';
    } else if (testUa(/windows nt 6.1|windows 7/g)) {
      systemVs = '7';
    } else if (testUa(/windows nt 6.2|windows 8/g)) {
      systemVs = '8';
    } else if (testUa(/windows nt 6.3|windows 8.1/g)) {
      systemVs = '8.1';
    } else if (testUa(/windows nt 10.0|windows 10/g)) {
      systemVs = '10';
    }
  } else if (system === 'macos') {
    systemVs = testVs(/os x [\d._]+/g);
  } else if (system === 'android') {
    systemVs = testVs(/android [\d._]+/g);
  } else if (system === 'ios') {
    systemVs = testVs(/os [\d._]+/g);
  }
  // 平台
  var platform = 'unknow';
  if (system === 'windows' || system === 'macos' || system === 'linux') {
    platform = 'desktop'; // 桌面端
  } else if (system === 'android' || system === 'ios' || testUa(/mobile/g)) {
    platform = 'mobile'; // 移动端
  }
  // 内核和载体
  var engine = 'unknow';
  var supporter = 'unknow';
  if (testUa(/applewebkit/g)) {
    engine = 'webkit'; // webkit内核
    if (testUa(/edge/g)) {
      supporter = 'edge'; // edge浏览器
    } else if (testUa(/opr/g)) {
      supporter = 'opera'; // opera浏览器
    } else if (testUa(/chrome/g)) {
      supporter = 'chrome'; // chrome浏览器
    } else if (testUa(/safari/g)) {
      supporter = 'safari'; // safari浏览器
    }
  } else if (testUa(/gecko/g) && testUa(/firefox/g)) {
    engine = 'gecko'; // gecko内核
    supporter = 'firefox'; // firefox浏览器
  } else if (testUa(/presto/g)) {
    engine = 'presto'; // presto内核
    supporter = 'opera'; // opera浏览器
  } else if (testUa(/trident|compatible|msie/g)) {
    engine = 'trident'; // trident内核
    supporter = 'iexplore'; // iexplore浏览器
  }
  // 内核版本
  var engineVs = 'unknow';
  if (engine === 'webkit') {
    engineVs = testVs(/applewebkit\/[\d._]+/g);
  } else if (engine === 'gecko') {
    engineVs = testVs(/gecko\/[\d._]+/g);
  } else if (engine === 'presto') {
    engineVs = testVs(/presto\/[\d._]+/g);
  } else if (engine === 'trident') {
    engineVs = testVs(/trident\/[\d._]+/g);
  }
  // 载体版本
  var supporterVs = 'unknow';
  if (supporter === 'chrome') {
    supporterVs = testVs(/chrome\/[\d._]+/g);
  } else if (supporter === 'safari') {
    supporterVs = testVs(/version\/[\d._]+/g);
  } else if (supporter === 'firefox') {
    supporterVs = testVs(/firefox\/[\d._]+/g);
  } else if (supporter === 'opera') {
    supporterVs = testVs(/opr\/[\d._]+/g);
  } else if (supporter === 'iexplore') {
    supporterVs = testVs(/(msie [\d._]+)|(rv:[\d._]+)/g);
  } else if (supporter === 'edge') {
    supporterVs = testVs(/edge\/[\d._]+/g);
  }
  // 外壳和外壳版本
  var shell = 'none';
  var shellVs = 'unknow';
  if (testUa(/micromessenger/g)) {
    shell = 'wechat'; // 微信浏览器
    shellVs = testVs(/micromessenger\/[\d._]+/g);
  } else if (testUa(/qqbrowser/g)) {
    shell = 'qq'; // QQ浏览器
    shellVs = testVs(/qqbrowser\/[\d._]+/g);
  } else if (testUa(/ucbrowser/g)) {
    shell = 'uc'; // UC浏览器
    shellVs = testVs(/ucbrowser\/[\d._]+/g);
  } else if (testUa(/qihu 360se/g)) {
    shell = '360'; // 360浏览器(无版本)
  } else if (testUa(/2345explorer/g)) {
    shell = '2345'; // 2345浏览器
    shellVs = testVs(/2345explorer\/[\d._]+/g);
  } else if (testUa(/metasr/g)) {
    shell = 'sougou'; // 搜狗浏览器(无版本)
  } else if (testUa(/lbbrowser/g)) {
    shell = 'liebao'; // 猎豹浏览器(无版本)
  } else if (testUa(/maxthon/g)) {
    shell = 'maxthon'; // 遨游浏览器
    shellVs = testVs(/maxthon\/[\d._]+/g);
  }
  return _objectSpread({
    engine: engine,
    engineVs: engineVs,
    platform: platform,
    supporter: supporter,
    supporterVs: supporterVs,
    system: system,
    systemVs: systemVs
  }, shell === 'none' ? {} : {
    shell: shell,
    shellVs: shellVs
  });
}
export var ua = navigator.userAgent.toLowerCase();
export var isMetisStudent = /Metis\/Student/i.test(ua) || window.location.hostname.startsWith('xuesheng');
export function onAvartarError(e) {
  // @ts-ignore
  e.target.src = getDefaultAvartar();
}
export function getDefaultAvartar() {
  if (isInStudent()) {
    return defaultStudentAvartar;
  }
  return defaultAvartar;
}
export var studentReg = /^https?:\/\/xuesheng\.feixiangxingqiu/;
export function isInStudent() {
  var redirect = getUrlQuery().redirectUrl || '';
  return isMetisStudent || studentReg.test(decodeURIComponent(redirect));
}
export function getWxRedirectUrl(url) {
  var _window$location = window.location,
    origin = _window$location.origin,
    pathname = _window$location.pathname,
    hash = _window$location.hash;
  if (url) {
    var objUrl = new URL(url);
    // eslint-disable-next-line prefer-destructuring
    origin = objUrl.origin;
    // eslint-disable-next-line prefer-destructuring
    pathname = objUrl.pathname;
    // eslint-disable-next-line prefer-destructuring
    hash = objUrl.hash;
  }
  var search = window.location.search;
  var query = qs.parse(search.slice(1));
  delete query.code;
  delete query.appId;
  delete query.csrfToken;
  search = qs.stringify(query);
  var result = "".concat(origin).concat(pathname).concat(search ? "?".concat(search) : '').concat(hash);
  return result;
}